import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getMonitoringAlerts(params, signal) {
  return request({
    url: '/alerts/list',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
    signal,
  });
}

export function getMonitoringAnalytics(params, signal) {
  return request({
    url: '/alerts/analytic',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
    signal,
  });
}

export function getMonitoringAlertsCount(params) {
  return request({
    url: '/alerts/count',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
  });
}

export function deleteAlert(uuid) {
  return request({
    url: `/alerts/${uuid}`,
    method: 'delete',
    data: uuid,
  });
}
